<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle2" :subheading="subheading2" />
      <div class="header-btn-box">
        <a @click="updateyqAppInfo">保存</a>
        <a @click="toConfigRoutinePage">取消</a>
      </div>
    </div>

    <form>
      <div class="form-title">租金管理账户：</div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">租金费收款账户名称：</span>
        </div>
        <el-select v-model="rentNo" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in aliAccountList"
            :key="item.aliAccountName"
            :label="item.aliAccountName"
            :value="item.aliAccountName">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">租金费收款支付宝账号：</span>
        </div>
        <el-input v-model="rentCode" size="small" style="width: 280px" disabled="" />
      </div>
      <div class="form-title">物业管理账户：</div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">物业费收款账户名称：</span>
        </div>
        <el-select v-model="propertyNo" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in aliAccountList"
            :key="item.aliAccountName"
            :label="item.aliAccountName"
            :value="item.aliAccountName">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">物业费收款支付宝账号：</span>
        </div>
        <el-input v-model="propertyCode" size="small" style="width: 280px" disabled="" />
      </div>
      <div class="form-title">停车管理账户：</div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">停车费收款账户名称：</span>
        </div>
        <el-select v-model="yqNo" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in aliAccountList"
            :key="item.aliAccountName"
            :label="item.aliAccountName"
            :value="item.aliAccountName">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">停车费收款支付宝账号：</span>
        </div>
        <el-input v-model="yqCode" size="small" style="width: 280px" disabled="" />
      </div>
      <div class="form-title">电费管理账户：</div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电费收款账户名称：</span>
        </div>
        <el-select v-model="electricNo" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in aliAccountList"
            :key="item.aliAccountName"
            :label="item.aliAccountName"
            :value="item.aliAccountName">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电费收款支付宝账号：</span>
        </div>
        <el-input v-model="electricCode" size="small" style="width: 280px" disabled="" />
      </div>
      <div class="form-title">场地费管理账户：</div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场地费收款账户名称：</span>
        </div>
        <el-select v-model="siteNo" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in aliAccountList"
            :key="item.aliAccountName"
            :label="item.aliAccountName"
            :value="item.aliAccountName">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场地费收款支付宝账号：</span>
        </div>
        <el-input v-model="siteCode" size="small" style="width: 280px" disabled="" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import {api} from '../../api/PayService'
import {errorHandler} from '../../../utils/errorHandler'
import {nSuccess} from '../../../utils/notice'

export default {
  components: {
    TextTitle,
    Breadcrumb},
  name: 'receiving-account-modify',
  data () {
    return {
      breadcrumb: [{
        value: '缴费服务',
        name: 'housing-management'
      }, {
        value: '收款账户配置'
      }],
      mainTitle2: '修改收款账户信息',
      subheading2: '园区收款账户信息配置',
      aliAccountList: [],
      aliAccountNo: '',
      aliAccountCode: '',
      // 租金
      rentNo: '',
      rentCode: '',
      rentRelateAliCode: '',
      rentData: {},
      // 物业
      propertyNo: '',
      propertyCode: '',
      propertyRelateAliCode: '',
      propertyData: {},
      // 停车
      yqNo: '',
      yqCode: '',
      yqRelateAliCode: '',
      yqData: {},
      // 电费
      electricNo: '',
      electricCode: '',
      electricRelateAliCode: '',
      electricData: {},
      // 场地费
      siteNo: '',
      siteCode: '',
      siteRelateAliCode: '',
      siteData: {},
    }
  },
  created () {
    this.getAliAccountList()
  },
  methods: {
    toConfigRoutinePage () {
      this.$router.push({
        name: 'receiving-account-configuration'
      })
    },
    getAliAccountList () {
      this.$axios.post(api.getAliAccountList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.aliAccountList = data
            this.getYqAppInfo()
          }
        })
        .catch(errorHandler('查询支付宝账户列表失败'))
    },

    getYqAppInfo () {
      this.$axios.post(api.getPaySettingList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            data.map(v => {
              if (v.code === 'A001') {
                this.rentData = v
                this.rentNo = v.relateAliName
              }
              if (v.code === 'A002') {
                this.propertyData = v
                this.propertyNo = v.relateAliName
              }
              if (v.code === 'A003') {
                this.yqData = v
                this.yqNo = v.relateAliName
              }
              if (v.code === 'A004') {
                this.electricData = v
                this.electricNo = v.relateAliName
              }
              if (v.code === 'A005') {
                this.siteData = v
                this.siteNo = v.relateAliName
              }
            })
          }
        })
        .catch(errorHandler('查询园区账户信息失败'))
    },
    updateyqAppInfo () {
      this.rentData.relateAliNo = this.rentCode
      this.rentData.relateAliCode = this.rentRelateAliCode
      this.rentData.relateAliName = this.rentNo

      this.propertyData.relateAliNo = this.propertyCode
      this.propertyData.relateAliCode = this.propertyRelateAliCode
      this.propertyData.relateAliName = this.propertyNo

      this.yqData.relateAliNo = this.yqCode
      this.yqData.relateAliCode = this.yqRelateAliCode
      this.yqData.relateAliName = this.yqNo

      this.electricData.relateAliNo = this.electricCode
      this.electricData.relateAliCode = this.electricRelateAliCode
      this.electricData.relateAliName = this.electricNo

      this.siteData.relateAliNo = this.siteCode
      this.siteData.relateAliCode = this.siteRelateAliCode
      this.siteData.relateAliName = this.siteNo
      let arr = []
      arr.push(this.rentData)
      arr.push(this.propertyData)
      arr.push(this.yqData)
      arr.push(this.electricData)
      arr.push(this.siteData)
      this.$axios.post(api.updatePaySetting, arr)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.toConfigRoutinePage()
          }
        })
        .catch(errorHandler('修改园区账户信息失败'))
    }
  },
  watch: {
    rentNo (val) {
      this.aliAccountList.map(v => {
        if (v.aliAccountName === val) {
          this.rentCode = v.aliAccountNo
          this.rentRelateAliCode = v.aliAccountCode
        }
      })
    },
    propertyNo (val) {
      this.aliAccountList.map(v => {
        if (v.aliAccountName === val) {
          this.propertyCode = v.aliAccountNo
          this.propertyRelateAliCode = v.aliAccountCode
        }
      })
    },
    yqNo (val) {
      this.aliAccountList.map(v => {
        if (v.aliAccountName === val) {
          this.yqCode = v.aliAccountNo
          this.yqRelateAliCode = v.aliAccountCode
        }
      })
    },
    electricNo (val) {
      this.aliAccountList.map(v => {
        if (v.aliAccountName === val) {
          this.electricCode = v.aliAccountNo
          this.electricRelateAliCode = v.aliAccountCode
        }
      })
    },
    siteNo (val) {
      this.aliAccountList.map(v => {
        if (v.aliAccountName === val) {
          this.siteCode = v.aliAccountNo
          this.siteRelateAliCode = v.aliAccountCode
        }
      })
    }
  }
}
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-title {
    color: #333333;
    font-size: 16px;
    line-height: 28px;
    padding-left: 5px;
    border-left: 3px solid #00a0e6;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 180px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }

  .newly {
    display: inline-block;
    width: 64px;
    height: 64px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }

  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }

  #pic {
    width: 64px;
    height: 64px;
  }

  .newly span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .newly span:first-child {
    font-size: 20px;
    line-height: 20px;
    position: absolute;
    top: 15px;
  }

  .newly2 span:first-child {
    font-size: 50px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }

  .newly span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }

  .newly2 span:last-child {
    font-size: 18px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }

  .upload {
    display: inline-block;
    width: 64px;
    height: 64px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload img, .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }

  .upload b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }

  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>



// WEBPACK FOOTER //
// src/view/PayService/ReceivingAccountConfiguration/ReceivingAccountModify.vue